import React, {useState} from 'react';
import cn from 'classnames';
import styles from './mychargers.module.scss';
import ChargerList from 'components/mychargers_component/ChargerList'
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import Layout from 'components/mychargers_component/Layout';
import { Auth } from 'aws-amplify';


export default function MyChargers(props) {
  const [LayoutOpen, setLayoutOpen] = useState(false)
  const handleToggle = () => {
    //disabling click for 13june
    // setLayoutOpen(!LayoutOpen)
  }

  configureRefreshToken();

  async function configureRefreshToken(){
  setInterval(() => {
    Auth.currentAuthenticatedUser()
    .then(data => {
      localStorage.setItem('signInUserSession', data);
      // this.LocalService.set(
      //   "token",
      //   data.signInUserSession?.accessToken?.jwtToken
      // );
      // if (data.attributes.name) {
      //   this.LocalService.set("accountname", data.attributes.name);
      // }
    })
    .catch(async err => {
      console.log(err);
      console.log('Error')
    });
  }, 10000);
}



//   // setTimeout(() => {
    
//   // }, timeout);
  return (
      <div
        className={`dash-board1 ${cn(
          styles.main_block,
          styles.main_block_layout
        )}`}>
       {/* <App/> */}
        <div className={cn(styles.main_flex, styles.main_flex_layout)}>
          
          <Header page_name='My Chargers' checkLayout={LayoutOpen}></Header>
          <div className= {`max:${LayoutOpen ? "hide" :"show"}`}>
          <ChargerList navState={handleToggle}></ChargerList>
          </div>
          <div className= {`max:${LayoutOpen ? "show" :"hide"}`}>
          
          <Layout navState={handleToggle} parking_slot_left_img='carParking' parking_slot_right_img='carParking' parking_slot_right_ic='carParking'
                  parking_slot_left_ic='carParking'></Layout>
            </div>
          <Footer></Footer>
        </div>
      </div>
  );
}

MyChargers.inStorybook = true;